import { render, staticRenderFns } from "./NotificationsSetup.vue?vue&type=template&id=443a53b0&scoped=true"
import script from "./NotificationsSetup.js?vue&type=script&lang=js&external"
export * from "./NotificationsSetup.js?vue&type=script&lang=js&external"
import style0 from "./NotificationsSetup.scss?vue&type=style&index=0&id=443a53b0&prod&scoped=true&lang=scss&external"
import style1 from "../User.scss?vue&type=style&index=1&id=443a53b0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443a53b0",
  null
  
)

export default component.exports